export type CountryType = {
  name: string;
  code: string;
  languageCode: string;
  phoneCode: string;
};

const globalCountries: CountryType[] = [
  {
    name: 'Netherlands',
    code: 'NL',
    languageCode: 'nl-nl',
    phoneCode: '31',
  },
  {
    name: 'Germany',
    code: 'DE',
    languageCode: 'de-de',
    phoneCode: '49',
  },
];

export default globalCountries;
